<template>
  <div class="OrderDetcontent">
    <van-row class="billDetail" v-if="orderDetail.orderId">
      <van-col span="24" class="cont">
        <van-col span="8" class="label">申请人：</van-col>
        <van-col span="16" class="orderId">{{orderDetail.createUser}}</van-col>
      </van-col >
      <van-col span="24" class="cont">
        <van-col span="8" class="label">申请时间：</van-col>
        <van-col span="16" class="orderId">{{orderDetail.createDate}}</van-col>
      </van-col >
      <van-col span="24" class="cont">
      	<van-col span="8" class="label">热力卡号：</van-col>
      	<van-col span="16" class="orderId">{{orderDetail.roomInfo.userCardNumber}}</van-col>
      </van-col >
      <van-col span="24" class="cont">
        <van-col span="8" class="label">地址：</van-col>
        <van-col span="16" class="orderId">{{orderDetail.roomInfo.roomAddress}}</van-col>
      </van-col >
      <van-col span="24" class="cont">
        <van-col span="8" class="label">原供热状态：</van-col>
        <van-col span="16" class="orderId">{{orderDetail.originalStatusText}}</van-col>
      </van-col >
      <van-col span="24" class="cont">
		  <van-col span="8" class="label">更改后供热状态：</van-col>
		  <van-col span="16" class="orderId">{{orderDetail.changeStatusText}}</van-col>
      </van-col >
      <van-col span="24" class="cont">
        <van-col span="8" class="label">审核状态：</van-col>
        <van-col span="16" class="orderId">{{orderDetail.statusText}}</van-col>
      </van-col >
		<van-col span="24" class="cont" v-if="orderDetail.status==2">
		  <van-col span="8" class="label">审批结果：</van-col>
		  <van-col span="16" class="orderId">{{orderDetail.result}}</van-col>
		  <van-col span="8" class="label">审批人：</van-col>
		  <van-col span="16" class="orderId">{{orderDetail.name}}</van-col>
		  <van-col span="8" class="label">审批时间：</van-col>
		  <van-col span="16" class="orderId">{{orderDetail.updateDate}}</van-col>
		</van-col >
      <van-col span="24" class="cont">
        <van-col span="8" class="label">备注：</van-col>
        <van-col span="16" class="orderId">{{orderDetail.remark}}</van-col>
      </van-col>
    </van-row>
  </div>
</template>

<script>
	export default {
    name:"orderdetail",
	  data(){
	    return{
        orderDetail:{},
      }
    },
    created(){
      this.orderDetail = this.$cookies.get('processorderInfo');
      if(this.orderDetail.result=='0'){
		   this.orderDetail.resultText='不通过';
	   }else if(this.orderDetail.result=='1'){
		   this.orderDetail.resultText='通过';
	   }
    },
    methods:{
      /*
      * 预览图片
      * */
      
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" >
  @import "../../common/stylus/mixins.styl"
  .OrderDetcontent
    padding 10px 0px
    .billDetail
      display block
      padding 30px 40px
      background #fff
      border-top 20px solid #f9f9f9
      .van-row
        padding-left 25px
      .cont
        border-bottom 2px solid #f0f0f0
        font-size 28px
        color #888888
        padding 20px 0px
      .address
        font-size 30px
        color #222222
        line-height 40px
        padding 0px 0px 20px
      .phone
        text-align right
      .time
        padding 20px 0px
        font-size 28px
        color #888888
      .orderId
        line-height 40px
        color #333333
      .timeB
        text-align right
        padding 20px 0px
        font-size 28px
        color #888888
      .statusText
        padding-top 20px
        font-size 28px
        color #888888
      .title
        font-size 30px
        color #333
        padding 20px 0px
      .reason
        padding 20px 20px
        color #999
        line-height 30px      
      .label
      	font-size 24px
</style>



// WEBPACK FOOTER //
// src/pages/Stop/detail.vue